import { useEffect, useState } from "react";
import { useGetPurchasersQuery } from "../../store/api";
import { Box, TextField, Typography, Paper } from "@mui/material";
import { useIsMobileView } from "../../utils/responsive";
import WinnerSearchResults from "../raffle/winnerSearch";
import { useAppSelector } from "../../store/hooks/useAppSelector";
import { RootState } from "../../store/types/rootState";

function useDebounce(value: string, delay: number): string {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(handler);
  }, [value, delay]);

  return debouncedValue;
}

export const WinnersPage = () => {
  const selectedRaffle = useAppSelector(({ selectedRaffle }: RootState) => selectedRaffle);

  const { data: purchasers } = useGetPurchasersQuery(selectedRaffle.id, {
    skip: selectedRaffle.id === 'default',
  });

  const [open, setOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const debouncedSearchTerm = useDebounce(searchTerm, 500);
  const isMobileView = useIsMobileView();

  return (
    <Box
      px={isMobileView ? 2 : 8}
      py={4}
      width="100%"
      display="flex"
      flexDirection="column"
      alignItems="center"
    >
      <Typography
        variant="h5"
        fontFamily="Georgia"
        fontWeight="bold"
        gutterBottom
        sx={{ textAlign: "center" }}
      >
        Ganadores del sorteo
      </Typography>

      <Paper
        elevation={3}
        sx={{
          width: '100%',
          maxWidth: 500,
          p: 4,
          borderRadius: 3,
          mt: 3,
        }}
      >
        <Typography
          variant="subtitle1"
          fontWeight="medium"
          sx={{ mb: 2, fontFamily: "inherit" }}
        >
          Buscar número ganador
        </Typography>

        <TextField
          id="ticket"
          label="Número de ticket"
          type="number"
          fullWidth
          variant="outlined"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            inputProps: { min: 0, max: 10000 },
          }}
        />

        {purchasers && selectedRaffle.id !== 'default' && (
          <Box mt={4}>
            <WinnerSearchResults
              setOpen={setOpen}
              raffleId={selectedRaffle.id}
              ticket={parseInt(debouncedSearchTerm)}
            />
          </Box>
        )}
      </Paper>
    </Box>
  );
};
